module.exports = __webpack_public_path__ + "static/media/southamerica-final1.38a7e71b.png";